// 古いバージョンのブラウザのために残す
import "core-js";

import "./assets/custom.scss";
import "@fortawesome/fontawesome-free/css/all.min.css";
import * as Sentry from "@sentry/browser";
import SentrySetting from "@graffer-inc/sentry-setting";
import "react-datepicker/dist/react-datepicker.css";
import "react-credit-cards/es/styles-compiled.css";
import "@graffer-inc/console-design-kit/lib/index.css";

import { ErrorBoundary } from "./components/error-boundary";
import { RootRoute } from "./components/route";
import { BrowserRouter, Switch } from "react-router-dom";
import { RootContextComponent } from "./global-state";
import { ToastContainer } from "react-toastify";
import { AuthContextComponent } from "./auth-state";
import { AuthUtil } from "./utils/auth";
import { initBrowserUserId } from "./utils/browser-userid-utils";
import { pdfjs } from "react-pdf";
import { buildSentryDSN } from "./utils/url-utils";
import { GrafferNotifService } from "./application/domain/notifi-from-graffer/notif-from-graffer-service";
import { createRoot } from "react-dom/client";
import { replaceFavicon } from "@graffer-inc/console-design-kit";
import { initSubtleErrorDetector } from "./components/subtle-error-detector";
import { StaticFeatureFlags } from "./feature-flags";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.js";

initBrowserUserId();
AuthUtil.configure("/api/v1/logout");
Sentry.init(
  SentrySetting.makeInit({
    environment: process.env.REACT_APP_ENVIRONMENT,
    release: process.env.SENTRY_RELEASE,
    // LGWAN環境からSentryのログを送るためには、一度、Grafferのサーバーを介して送る必要があるため、
    // フロントエンドのNginxサーバーに送るようにDSN設定を行う
    // また、実行環境がLGWAN / インターネットがありドメインも異なるため、動的に生成している
    dsn: process.env.REACT_APP_SENTRY_DSN
      ? process.env.REACT_APP_SENTRY_DSN
      : buildSentryDSN(),
  }),
);

document.addEventListener(
  "securitypolicyviolation",
  (evt: SecurityPolicyViolationEvent) => {
    const { target } = evt;
    const extraData = {
      event: evt,
      blockedURI: evt.blockedURI,
      violatedDirective: evt.violatedDirective,
      originalPolicy: evt.originalPolicy,
      activeElement: "",
    };

    if (target instanceof Document && target.activeElement) {
      extraData.activeElement = target.activeElement.outerHTML;
    }

    Sentry.captureException(new Error(evt.type), {
      extra: extraData,
    });
  },
);

// タイミングとしては通知が表示されることを保証していないが、そこまでシビアな機能ではないため、許容
GrafferNotifService.init();

// デプロイ環境に応じてfaviconを差し替える
const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
if (link && process.env.REACT_APP_ENVIRONMENT) {
  // TODO(adshidtadka): console-design-kitのEnvLiteral型を使う
  replaceFavicon(link, process.env.REACT_APP_ENVIRONMENT as any);
}

StaticFeatureFlags.ENABLE_SUBTLE_ERROR_DETECTOR && initSubtleErrorDetector();

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <ErrorBoundary>
    <ToastContainer autoClose={2000} />
    <RootContextComponent>
      <AuthContextComponent>
        <BrowserRouter>
          <Switch>
            <RootRoute />
          </Switch>
        </BrowserRouter>
      </AuthContextComponent>
    </RootContextComponent>
  </ErrorBoundary>,
);
